import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import en from 'vuetify/src/locale/en.ts'
import ru from 'vuetify/src/locale/ru.ts'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { en, ru },
    current: 'en'
  },
  theme: {
    dark: !!JSON.parse(localStorage.getItem('dark_theme'))
  }
})
